import { forwardRef } from "react";
import { Control, Controller, FieldError } from "react-hook-form";
import { CountryIso2, PhoneInput } from "react-international-phone";
import clsx from "clsx";

interface IFormInputs {
  username: string;
  email: string;
  password: string;
  passwordCheck: string;
  firstName: string;
  lastName: string;
  schoolGrade?: string;
  phone?: string;
  parentEmail?: string;
  role?: string;
  birthday?: string;
  city?: string;
  isTeacher: boolean;
  teacherOf?: string;
  termsAccepted?: boolean;
}

/* eslint-disable-next-line */
export interface WPhoneInputWrapperProps {
  country?: CountryIso2;
  control: Control<IFormInputs, any>;
  name: "phone";
  errorMessage?: FieldError;
  required?: boolean;
}

export const WPhoneInputWrapper = forwardRef<
  HTMLInputElement,
  WPhoneInputWrapperProps
>((props, ref) => {
  const { country = "ro", control, name, errorMessage, required } = props;

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: required,
      }}
      render={({ field: { onChange, value } }) => (
        <PhoneInput
          className={clsx([
            "ek-input phoneInput",
            errorMessage && "border border-red-500",
          ])}
          defaultCountry={country}
          value={value}
          onChange={onChange}
        />
      )}
    />
  );
});

export default WPhoneInputWrapper;
